export default __webpack_public_path__ + "static/media/Engineering.e079c2df.jpg";